import Stack from '@mui/material/Stack';
import { Button, Typography } from '@sweep-io/sweep-design';
import usePageblockEvents from '../../../../../hooks/usePageblockEvents';

export const BookADemoButton = () => {
  const { bookDemoAndSendEvent } = usePageblockEvents();

  return (
    <Stack pt={'102px'} pb={11} width="358px">
      <Stack gap={3} alignItems="center">
        <Typography variant="h1-medium" textAlign="center">
          See how Sweep transforms your business
        </Typography>
        <Button
          size="medium"
          onClick={() => {
            bookDemoAndSendEvent();
          }}
        >
          Book a demo
        </Button>
      </Stack>
    </Stack>
  );
};
